import React, { useCallback } from 'react';
import { ExperienceFailed } from '@atlassian/jira-business-experience-tracking/src/controllers/experience-tracker/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useProject } from '@atlassian/jira-business-entity-project-hook/src/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { LIST_FORMAT_RULE_EXPERIENCE } from '../../../common/constants.tsx';
import { formatRulesEntryPoint } from '../sidebar/entrypoint.tsx';
import { useFormatRulesSerialisedJql } from '../../../controllers/format-rules-store/index.tsx';
import { SidebarFallback } from '../sidebar/fallback/index.tsx';
import { useFormatRulesSidebar } from '../../../controllers/sidebar/index.tsx';

export interface GetFormatRulesClickReturn {
	onClickFormatButton: ({ showOnboarding }: { showOnboarding: boolean }) => void;
}

export const useGetFormatRulesClick = (): GetFormatRulesClickReturn => {
	const cloudId = useCloudId();
	const projectData = useProject();
	const [hydrateJql] = useFormatRulesSerialisedJql();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(formatRulesEntryPoint, {
		projectKey: projectData.key,
		cloudId,
		hydrateJql,
	});

	const errorFallback = useCallback(
		({ error }: { error: Error }) => (
			// TODO: show error flag
			<ExperienceFailed experience={LIST_FORMAT_RULE_EXPERIENCE} error={error} />
		),
		[],
	);

	const { onClickFormatButton } = useFormatRulesSidebar({
		SidebarComponent: (props) => (
			<JiraEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="jwm.business.format.rules"
				packageName="jiraBusinessFormatRules"
				runtimeProps={props}
				fallback={<SidebarFallback />}
				errorFallback={errorFallback}
			/>
		),
		projectId: String(projectData.id),
	});

	const onClick = useCallback(
		({ showOnboarding }: { showOnboarding: boolean }) => {
			entryPointActions.load();
			onClickFormatButton({ showOnboarding });
		},
		[entryPointActions, onClickFormatButton],
	);

	return {
		onClickFormatButton: onClick,
	};
};
